<div class="reportSpacing">
  <div>
    <div>
      <!-- Piqet Logo & Organization Logo -->
      <div
        class="logo-div d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-start align-items-md-center"
      >
        <div class="m-0 p-0">
          <img [src]="piqetLogo" id="piqetLogo" alt="Piqet logo" />
        </div>
        <div class="m-0 p-0">
          <img
            [src]="reportData?.organizationLogo"
            id="organizationLogo"
            alt="Organization image"
          />
        </div>
      </div>

      <!-- Project name -->
      <div class="main-contant">
        <div class="maintext-heading">
          <span class="purpleProjectName">{{ mainProjectName | titlecase }}</span>
          {{ remainingProjectName | titlecase }} -
          <br />
          {{ reportResource.lblDetailedReport }}
        </div>
      </div>
      <!-- Scenario Image List -->
      <div *ngIf="reportData?.scenarioImageList">
        <div *ngFor="let scenarioImage of reportData?.scenarioImageList">
          <img src="scenarioImage" class="scenarioImage" alt="Scenario image" />
        </div>
      </div>
      <!-- Profile Image -->
      <div class="profile-detail-div">
        <div class="profile-image-div">
          <img [src]="'data:image/jpg;base64,' + reportData?.profileImage" alt="Profile image" />
        </div>
        <div class="profile-detail">
          <p class="userNameOrorganization">{{ reportData?.username }}</p>
        </div>
      </div>
      <!-- Organization name -->
      <div class="organizatio-name-div">
        <div class="organizatio-name">
          <p class="userNameOrorganization">{{ reportData?.organizationName }}</p>
        </div>
      </div>

      <div class="bottom-contant">
        <div class="">Generated by</div>
        <div class="">George heathcote</div>
        <div class="">Other.side studio</div>
      </div>

      <div class="last-bottom-contant">
        <div class="">PIQET project code : {{ reportData?.projectCode }}</div>
        <div class="">Report generated : {{ getFormateDate(reportData?.reportGeneratedDate) }}</div>
        <div class="">Software version : PIQET {{ reportData?.softwareVersion }}</div>
      </div>
    </div>
  </div>

  <div class="main-div">
    <div class="reportContent">
      <!-- Project detail -->
      <div class="project-detail-div page-break">
        <!-- Title -->
        <div class="row space">
          <h1 class="headingTitle">Project details</h1>
        </div>
        <!-- Table & Table title -->
        <div class="row table-div">
          <div class="tableHeading">
            <h3>{{ reportResource.lblSummaryProject }}</h3>
          </div>
          <div class="table-content">
            <table class="table">
              <thead>
                <tr>
                  <td>PIQET project code</td>
                  <td>{{ reportData?.projectCode }}</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Name</td>
                  <td>{{ reportData?.projectName }}</td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td>{{ reportData?.projectDescription }}</td>
                </tr>
                <tr>
                  <td>Share with</td>
                  <td>{{ reportData?.shareWith }}</td>
                </tr>
                <tr>
                  <td>Status</td>
                  <td>{{ reportData?.status }}</td>
                </tr>
                <tr>
                  <td>Currency</td>
                  <td>{{ reportData?.currency }}</td>
                </tr>
                <tr>
                  <td>Default country</td>
                  <td>{{ reportData?.defaultCountry }}</td>
                </tr>
                <tr>
                  <td>Other countries</td>
                  <td>{{ reportData?.otherCountries }}</td>
                </tr>
                <tr>
                  <td>Basic for comparison</td>
                  <td>{{ reportData?.basisforComparision }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- Table & Table title -->
        <div class="row table-div" *ngIf="reportData?.propackscenarioList.length > 0">
          <div class="tableHeading">
            <h3>{{ reportResource.lblSummaryScenarios }}</h3>
          </div>
          <div class="table-content">
            <table class="table">
              <thead>
                <tr>
                  <td>Package product system</td>
                  <td>Package</td>
                  <td>Product</td>
                  <td>Product quantity</td>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let scenario of reportData?.propackscenarioList">
                  <td>{{ scenario.propackScenarioname }}</td>
                  <td>{{ scenario.package }}</td>
                  <td>{{ scenario.productSector }}</td>
                  <td>{{ scenario.productQuantity }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div *ngIf="!!reportData.spiderChartItemsData?.projectInterpretation">
          <!-- need to check content -->
          <h2>{{ reportResource.lblInterpretation }}</h2>
          <div [innerHTML]="interpretedText" class="innerText"></div>
        </div>
      </div>

      <div>
        <div class="page-break"></div>
        <div>
          <div class="row space">
            <h1 class="headingTitle">{{ reportResource.lblScenarioComparison }}</h1>
          </div>
          <div class="row">
            <div class="headingTitle">
              <h2>
                {{ reportResource.lblCarbonFootPrint }} {{ reportResource.lblLifeCyclesStages }}
              </h2>
            </div>
          </div>
          <div>
            <p class="para">{{ reportResource.lblCarbonLifeCycle }}</p>
          </div>
          <br />
        </div>

        <div
          *ngFor="
            let indicatorDetail of reportData.lifeCycleStageContributionImpactItems;
            let i = index
          "
        >
          <div [ngClass]="i == 0 ? '' : 'page-break'"></div>
          <div class="tableHeadingForLifecycleStage">
            <h3>
              {{ reportResource.lblTable }} {{ lifeCycleStageContributionImpactItemsTableId + i }}:
              {{ indicatorDetail.indicatorName }}
              {{ reportResource.lblLifeCycle }} -
              {{ reportData?.functionalUnitName | lowercase }}
            </h3>
          </div>
          <div style="margin: 0px -7px">
            <piqet-angular-life-cycle-stage-chart
              [indicatorDetail]="indicatorDetail.impactItems"
            ></piqet-angular-life-cycle-stage-chart>
          </div>
          <p class="figureIdClass">
            {{ reportResource.lblFigure }} {{ lifeCycleStageContributionImpactItemsFigureId + i }}:
            {{ reportResource.lblCarbonFootPrint }} {{ reportResource.lblComparison }}
            {{ reportResource.lblLifeCycle }} - {{ reportData?.functionalUnitName | lowercase }}
          </p>
        </div>
      </div>

      <div>
        <div class="page-break"></div>
        <div>
          <div class="row sub-title-class">
            <div class="headingTitle">
              <h2>{{ reportResource.lblCarbonFootPrint }} {{ reportResource.lblPackingLevel }}</h2>
            </div>
          </div>
          <div>
            <p class="para">{{ reportResource.lblCarbonPackagingLevel }}</p>
          </div>
        </div>

        <div
          *ngFor="
            let indicatorDetail of reportData.packagingLevelContributionImpactItems;
            let i = index
          "
        >
          <div [ngClass]="i == 0 ? '' : 'page-break'"></div>
          <h3 class="indicatorName">
            <span class="Titalcase">{{ indicatorDetail.indicatorName }}</span
            >&nbsp; ({{ indicatorDetail.indicatorUnitName }})
          </h3>
          <div>
            <p class="para">{{ reportResource.lblCarbonPackagingLevelIndicator }}</p>
          </div>
          <div class="tableHeadingForLifecycleStage">
            <h3>
              {{ reportResource.lblTable }} {{ packagingLevelContributionImpactItemsTableId + i }}:
              {{ indicatorDetail.indicatorName }}
              {{ reportResource.lblPackingLevelStage }} -
              {{ reportData?.functionalUnitName | lowercase }}
            </h3>
          </div>
          <div style="margin-bottom: 30px">
            <piqet-angular-report-bar-chart
              [impactItems]="indicatorDetail.impactItems"
            ></piqet-angular-report-bar-chart>
          </div>
          <p class="figureIdClass">
            {{ reportResource.lblFigure }} {{ packagingLevelContributionImpactItemsFigureId + i }}:
            {{ reportResource.lblCarbonFootPrint }} {{ reportResource.lblComparison }} of
            {{ reportResource.lblPackingLevelStage }}
            {{ reportData?.functionalUnitName | lowercase }}
          </p>
        </div>
      </div>

      <div>
        <div class="page-break"></div>
        <div>
          <div class="row sub-title-class">
            <div class="headingTitle">
              <h2>{{ reportResource.lblComponents }} {{ reportResource.lblCarbonFootPrint }}</h2>
            </div>
          </div>
          <div>
            <p class="para">{{ reportResource.lblCarbonComponentLevel }}</p>
          </div>
        </div>
        <div *ngFor="let indicatorDetail of reportData.componentContributionItems; let i = index">
          <div [ngClass]="i == 0 ? '' : 'page-break'"></div>
          <div class="tableHeadingForLifecycleStage">
            <h3>
              {{ reportResource.lblTable }} {{ componentContributionItemsTableId + i }}:
              {{ indicatorDetail.indicatorName }}
              {{ reportResource.lblComponents }} -
              {{ reportData?.functionalUnitName | lowercase }}
            </h3>
          </div>
          <div style="margin-bottom: 30px">
            <piqet-angular-report-bar-chart-component
              [impactItems]="indicatorDetail.impactItems"
            ></piqet-angular-report-bar-chart-component>
          </div>
          <p class="figureIdClass">
            {{ reportResource.lblFigure }} {{ componentContributionItemsFigureId + i }}:
            {{ reportResource.lblCarbonFootPrint }} {{ reportResource.lblComponents }} -
            {{ reportData?.functionalUnitName | lowercase }}
          </p>
        </div>
      </div>

      <div *ngIf="reportData.isProductContent && !reportData.isExcludeProductImpacts">
        <div class="page-break"></div>
        <div>
          <div class="row sub-title-class">
            <div class="headingTitle">
              <h2>{{ reportResource.lblCarbonFootPrint }} {{ reportResource.lblIngredient }}</h2>
            </div>
          </div>
          <div>
            <p class="para">{{ reportResource.lblCarbonIngredientLevel }}</p>
          </div>
        </div>
        <div *ngFor="let indicatorDetail of reportData.ingredientContributionItems; let i = index">
          <div [ngClass]="i == 0 ? '' : 'page-break'"></div>
          <div class="tableHeadingForLifecycleStage">
            <h3>
              {{ reportResource.lblTable }} {{ ingredientContributionItemsTableId + i }}:
              {{ indicatorDetail.indicatorName }}
              {{ reportResource.lblIngredient }} -
              {{ reportData?.functionalUnitName | lowercase }}
            </h3>
          </div>
          <div style="margin-bottom: 30px">
            <piqet-angular-report-bar-chart-ingredient
              [impactItems]="indicatorDetail.impactItems"
            ></piqet-angular-report-bar-chart-ingredient>
          </div>
          <p class="figureIdClass">
            {{ reportResource.lblFigure }} {{ ingredientContributionItemsFigureId + i }}: Carbon
            footprint {{ reportResource.lblIngredient }} -
            {{ reportData?.functionalUnitName | lowercase }}
          </p>
        </div>
      </div>

      <div>
        <div class="page-break"></div>
        <div class="row sub-title-class">
          <div class="headingTitle">
            <h2>
              {{ reportResource.lblCarbonFootPrint }} {{ reportResource.lblContributionTransport }}
            </h2>
          </div>
        </div>
        <div class="tableHeadingForLifecycleStage">
          <h3>{{ reportResource.lblCarbonTransportLevel }}</h3>
        </div>
      </div>
      <div *ngFor="let indicatorDetail of reportData.transportContributionItems; let i = index">
        <div [ngClass]="i == 0 ? '' : 'page-break'"></div>
        <div class="tableHeadingForLifecycleStage">
          <h3>
            {{ reportResource.lblTable }} {{ transportContributionItemsTableId + i }}:
            {{ indicatorDetail.indicatorName }} -
            {{ reportData?.functionalUnitName | lowercase }}
          </h3>
        </div>
        <div style="margin-bottom: 30px">
          <piqet-angular-report-bar-chart
            [impactItems]="indicatorDetail.impactItems"
          ></piqet-angular-report-bar-chart>
        </div>
        <p class="figureIdClass">
          {{ reportResource.lblFigure }} {{ transportContributionItemsFigureId + i }}:
          {{ reportResource.lblContributionTransport }} to the
          {{ reportResource.lblCarbonFootprintReport }} -
          {{ reportData?.functionalUnitName | lowercase }}
        </p>
      </div>
    </div>
  </div>
</div>
